import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {excelPluginUsageReportsStateSelector} from './excel-plugin-usage-reports-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {ReportMetadata} from 'src/openapi/admin/models/ReportMetadata';

export const excelPluginUsageReportsSlice = getCachedTableDataSlice<
    ReportMetadata[],
    undefined,
    undefined,
    undefined
>('excelPluginUsageReports');

export const excelPluginUsageReportsActions = excelPluginUsageReportsSlice.actions;
const excelPluginUsageReportsCacheSelector: CachedTableCacheSelector<ReportMetadata[]>
    = state => state.accountPage.tabs.licenseAndFeatures.reports.excelPluginUsageReport.reports.cache;
export const excelPluginUsageReportsDataSelector: CachedTableDataSelector<ReportMetadata[]>
    = state => state.accountPage.tabs.licenseAndFeatures.reports.excelPluginUsageReport.reports;
export const excelPluginUsageReportsResultSelector = getCachedTableResultSelector(
    excelPluginUsageReportsCacheSelector,
    excelPluginUsageReportsStateSelector,
);
